export const INTERNSHIPS = [
  {
    slug: "ai-ml",
    title: "Artificial Intelligence & Machine Learning",
    tag: "Paid",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1400&q=80",
    location: "Bangalore",
    duration: "1, 2, or 3–4 Months",
    mode: "On-site (Offline) / Online / Hybrid",
    short:
      "The AI & ML Internship by Scontinent Technologies offers hands-on training in Python, core ML algorithms, predictive modeling, and deployment techniques with mentor-guided real-world projects.",
    long: [
      "Master the full AI/ML lifecycle — from data pipelines and feature engineering to model training, evaluation, and deployment.",
      "Work on live projects using Python, TensorFlow, PyTorch, scikit-learn, and modern MLOps tooling under senior mentor supervision.",
      "Ideal for students who want to build production-grade intelligent systems and gain a competitive edge in the AI economy.",
    ],
    skills: ["Python", "NumPy / Pandas", "scikit-learn", "TensorFlow / PyTorch", "Model Deployment", "MLOps"],
  },
  {
    slug: "full-stack",
    title: "Full Stack Developer",
    tag: "Paid",
    image: "https://images.unsplash.com/photo-1587620962725-abab7fe55159?auto=format&fit=crop&w=1400&q=80",
    location: "Bangalore",
    duration: "1, 2, or 3–4 Months",
    mode: "On-site (Offline) / Online / Hybrid",
    short:
      "The Full Stack Development Internship by Scontinent Technologies offers hands-on training in React, Node.js, and databases. Build real-time web applications under senior mentor supervision.",
    long: [
      "Build end-to-end applications with modern frameworks — React on the front, Node.js + Express or FastAPI on the back, and SQL/NoSQL databases beneath.",
      "Learn version control, CI/CD, API design, authentication, and cloud deployment with real-world engineering rigour.",
      "Graduate with a production-quality portfolio and the confidence to ship software professionally.",
    ],
    skills: ["React", "Node.js / Express", "MongoDB / PostgreSQL", "REST & GraphQL APIs", "Git & CI/CD", "Cloud Deploy"],
  },
  {
    slug: "data-science",
    title: "Data Science & Analytics",
    tag: "Paid",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1400&q=80",
    location: "Bangalore",
    duration: "1, 2, or 3–4 Months",
    mode: "On-site (Offline) / Online / Hybrid",
    short:
      "The Data Analytics Internship by Scontinent Technologies offers hands-on training in Python, SQL, Power BI, and data visualization. Work on real-world datasets from Sales, HR, and Finance.",
    long: [
      "Turn raw data into decisions. Learn to query, clean, model, and visualise information at scale.",
      "Practice on live datasets across Sales, HR, and Finance domains — the same problems companies face every day.",
      "Master Python, SQL, Power BI, Excel, and statistical thinking to become a data-driven analyst.",
    ],
    skills: ["Python", "SQL", "Power BI", "Statistics", "Data Visualization", "Business Insights"],
  },
  {
    slug: "cybersecurity",
    title: "Cybersecurity",
    tag: "Paid",
    image: "https://images.pexels.com/photos/5866051/pexels-photo-5866051.jpeg?auto=compress&cs=tinysrgb&w=1400",
    location: "Bangalore",
    duration: "1, 2, or 3–4 Months",
    mode: "On-site (Offline) / Online / Hybrid",
    short:
      "Practical, mentor-led training in information security. Gain experience in vulnerability assessment, incident response, security monitoring, and ethical hacking to ensure digital safety.",
    long: [
      "Step inside the mind of an attacker — and a defender. Learn how organisations are compromised and how to protect them.",
      "Hands-on labs cover vulnerability assessment, penetration testing, SOC operations, and incident response.",
      "Emerge job-ready with skills that are in critical demand across every industry.",
    ],
    skills: ["Network Security", "Pen Testing", "SIEM Tools", "Incident Response", "Ethical Hacking", "OWASP"],
  },
  {
    slug: "ui-ux",
    title: "UI/UX Design",
    tag: "Paid",
    image: "https://images.unsplash.com/photo-1680016661694-1cd3faf31c3a?auto=format&fit=crop&w=1400&q=80",
    location: "Bangalore",
    duration: "1, 2, or 3–4 Months",
    mode: "On-site (Offline) / Online / Hybrid",
    short:
      "Design intuitive, user-centered digital products from wireframing to high-fidelity prototypes. Work on real design challenges using industry-standard tools with expert feedback.",
    long: [
      "Craft interfaces people love. Learn design thinking, user research, wireframing, and interaction design.",
      "Build a portfolio of high-fidelity prototypes using Figma, aligned with modern accessibility and design system principles.",
      "Receive weekly critique from working designers — the fastest path from student to professional.",
    ],
    skills: ["Figma", "Design Systems", "User Research", "Prototyping", "Accessibility", "Interaction Design"],
  },
  {
    slug: "cloud-devops",
    title: "Cloud Computing & DevOps",
    tag: "Paid",
    image: "https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?auto=format&fit=crop&w=1400&q=80",
    location: "Bangalore",
    duration: "1, 2, or 3–4 Months",
    mode: "On-site (Offline) / Online / Hybrid",
    short:
      "Learn cloud architecture, deployment pipelines, containerization, and infrastructure automation with AWS and DevOps tools. Build scalable, enterprise-grade cloud solutions.",
    long: [
      "Modern software runs on the cloud. Learn to architect, deploy, and operate systems on AWS and beyond.",
      "Master Docker, Kubernetes, Terraform, and CI/CD pipelines that power today’s tech companies.",
      "Finish the programme with a portfolio of scalable, resilient, production-grade cloud deployments.",
    ],
    skills: ["AWS", "Docker", "Kubernetes", "Terraform", "CI/CD", "Monitoring"],
  },
];

export const TECHNICAL_DOMAINS = [
  "AI/ML",
  "Data Science",
  "Full Stack Development",
  "Front End Development",
  "Back End Development",
  "Software Testing",
  "App Development",
  "UI-UX Design",
  "Cloud Computing",
  "Cyber Security",
  "VLSI & Embedded Systems",
  "Communication Systems & Networking",
  "Digital Signal Processing",
  "Robotics & Automation",
  "Microelectronics & Photonics",
  "EV (Electric Vehicles)",
  "AutoCAD (Mechanical)",
];

export const NON_TECHNICAL_DOMAINS = [
  "Finance",
  "Human Resource",
  "Marketing",
  "Digital Marketing",
  "PowerBI",
  "Data Analytics",
  "Logistics",
  "Entrepreneurship",
  "Search Engine Optimization (SEO)",
  "Operational Management",
];

export const QUALIFICATIONS = ["B.E", "B.Tech", "BCA", "MCA", "M.Tech", "B.Sc", "M.Sc", "Other"];
